{
  "cms.order.announce.dropped": "Item {title} was dropped.",
  "cms.order.announce.movedTo": "Item {title} was moved to position {position} of {total}.",
  "cms.order.announce.cancelled": "Moving item {title} was cancelled.",
  "cms.order.announce.pickedUp": "Item {title} was picked up. Use the arrow keys to move, space to drop.",
  "cms.order.announce.instructions": "Press space to pick up an item, arrow keys to move it, space to drop, or escape to cancel.",
  "cms.order.handle.label": "Reorder: {title}",
  "cms.order.editTrigger": "Edit order",
  "cms.order.pendingBadge": "Order changes (in drafts)",
  "cms.order.sectionTitle": "Order: {scope}",
  "cms.order.sectionHint": "Drag the items into the order you want. The change is visible to members only after publishing.",
  "cms.order.wasAt": "(was {position}.)",
  "cms.order.publish": "Publish order",
  "cms.order.publishing": "Publishing…",
  "cms.order.discard": "Discard order change",
  "cms.order.discarding": "Discarding…",
  "cms.order.stageError": "Saving the order failed. Please try again.",
  "cms.order.publishError": "Publishing the order failed. Please try again.",
  "cms.order.discardError": "Discarding the order change failed. Please try again."
}
